import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  cardTop: {
    display: 'flex',
    backgroundColor: 'white',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  card: {
    padding: 32
  },
  label: {
    color: theme.colors.green_15,
    fontSize: 16
  },
  divider: {
    background: theme.colors.page__background_primary,
    width: '85%',
    margin: 'auto',
    marginBottom: 16,
    marginTop: 16
  },
  lowerLabel: {
    color: '#717832',
    fontSize: 12,
    marginLeft: 5
  },
  bottomMessage: {
    display: 'flex',
    alignItems: 'flex-start'
  }
});

export default makeStyles(styles);
